<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div v-for="cat in rubric.categories" :key="cat.id">
					<div class="row align-items-end">
						<div class="form-group col-4">
							<label>Name</label>
							<input type="text" v-model="cat.name" class="form-control" placeholder="Category name..." />
						</div>
						<div class="form-group col-8 d-flex flex-row align-items-end">
							<div class="flex">
								<label>Prompt</label>
								<input
									type="text"
									v-model="cat.prompt"
									class="form-control"
									placeholder="Prompt for feedback..."
								/>
							</div>
							<div class="ml-4">
								<div>
									<label class="md-check check-sm mt-2">
										<input type="checkbox" checked="checked" v-model="cat.required_score" />
										<i class="cyan"></i> Require Score
									</label>
								</div>
								<div v-if="!hideReasoning">
									<label class="md-check check-sm mt-1">
										<input type="checkbox" checked="checked" v-model="cat.required_reasoning" />
										<i class="cyan"></i> Require Reasoning
									</label>
								</div>
							</div>
							<div class="ml-4 mb-2" v-if="details">
								<button
									class="btn-no-border btn-si-blue btn-si-icon ml-2"
									@click="cat.details = !cat.details"
									v-tippy
									:title="cat.details ? 'Hide Details' : 'Show Details'"
								>
									<i class="fas fa-sliders-h-square"></i>
								</button>
							</div>
							<div class="ml-2 mr-4 mb-2">
								<button
									class="btn-no-border btn-si-orange btn-si-icon ml-2"
									@click="remove(cat)"
									v-tippy
									title="Remove"
								>
									<i class="fas fa-minus"></i>
								</button>
							</div>
						</div>
						<div v-if="cat.details" class="col-12">
							<div class="mb-3 px-3 pb-3 pt-2 card">
								<div class="mb-2 pl-2 pr-3">
									<hundred-slider :marks="fs.constructSliderMarks(cat.marks)" />
								</div>
								<div class="row">
									<template v-for="(mark, i) in cat.marks">
										<template v-if="mark.type == 0">
											<div
												:key="`tick2-${i}`" 
												v-if="i != 0"
												class="col-2 mb-2">
												<label>End</label>
												<input type="number" class="form-control" v-model.number="mark.tick" />
											</div>
											<div
												:key="`tick2-${i}`"
												v-if="i == 0"
												class="col-2 mb-2">
												<label>Start</label>
												<input type="number" class="form-control" v-model.number="mark.tick" />
											</div>
											<div
												:key="`button-${i}`"
												v-if="i != 0"
												class="col-1 mb-2 ml-0 pl-0"
												style="padding-top: 2px"
											>
												<button
													class="btn-no-border btn-si-orange btn-si-icon"
													@click="removeMark(cat, mark)"
													v-tippy
													title="Remove"
												>
													<i class="fas fa-minus"></i>
												</button>
											</div>
											<div
												:key="`tick1-${i}`"
												v-if="i != 0 && i != cat.marks.length - 1"
												class="col-2 mb-2"
											>
                                                <label>Start</label>
												<input type="number" class="form-control" v-model.number="mark.tick" />
											</div>
										</template>
										<div v-if="mark.type == 1" :key="`label-${i}`" class="col-3 mb-2">
											<label>Label</label>
											<input type="text" class="form-control" v-model="mark.label" />
										</div>
										<div v-if="mark.type == 1" :key="`description-${i}`" class="col-4 mb-2">
											<label>Description</label>
											<RichText
												:text.sync="mark.description"
												:initial="mark.initDescription"
												:options="{height: 52, toolbar: [['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']], ['para', ['ul', 'ol']]]}"
											/>
										</div>
									</template>
								</div>

								<button class="btn btn-primary mr-auto" @click="addMark(cat)">Add</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button class="btn btn-primary" @click="add">Add</button>
	</div>
</template>

<style scoped>
</style>

<script>
import HundredSlider from "@/components/HundredSlider";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import RichText from "@/components/RichText";
import _ from "lodash";

export default {
	name: "RubricEditComponent",
	props: ["rubric", "configureMarks", "details", "canEdit", "hideReasoning"],

	components: { HundredSlider, RichText },

	data() {
		return {
			fs: fs,
		};
	},
	mounted() {
		for (var cat of this.rubric.categories) {
			for (var mark of cat.marks) {
				mark.initDescription = mark.description;
			}
		}
	},
	watch: {},
	methods: {
		add() {
			if (!this.canEdit) {
				Notie.error("Can't edit rubric: responses already submitted");
				return;
			}
			let newCat = {
				id: Math.random().toString(36).slice(2),
				name: "",
				prompt: "",
				text_feedback: false,
				required_score: true,
				required_reasoning: true,
				marks: [],
				details: false,
			};

			if (this.configureMarks) {
				newCat.marks = [
					{ type: 0, label: "", tick: 0 },
					{ type: 1, label: "Rating", description: "", tick: 0 },
					{ type: 0, label: "", tick: 100 },
				];
			}

			if (!this.rubric.categories) {
				this.rubric.categories = [];
			}

			this.rubric.categories.push(newCat);
		},

		remove(category) {
			if (!this.canEdit) {
				Notie.error("Can't edit rubric: responses already submitted");
				return;
			}
			this.rubric.categories = _.without(this.rubric.categories, category);
		},

		addMark(cat) {
			if (!cat.marks) {
				this.$set(cat, "marks", []);
			}

			if (cat.marks.length == 0) {
				cat.marks.push({
					type: 0,
					tick: 0,
				});
			}

			let lastTick = cat.marks[cat.marks.length - 1];
			cat.marks.push({
				type: 1,
				label: "",
			});
			cat.marks.push({
				type: 0,
				tick: lastTick.tick + 10,
			});
		},

		removeMark(cat, mark) {
			let index = cat.marks.indexOf(mark);
			if (index == -1) return;

			// Delete the tick
			this.$delete(cat.marks, index);
			// Also delete the label that came before the tick
			// Since the tick in the 0th position doesn't have a remove button associated with it,
			// this should never go out of bounds
			this.$delete(cat.marks, index - 1);
		},
	},
};
</script>